/* eslint-disable */
require('./avatar_geral')
require('./calendar')
require('./error_404')
require('./flag-es')
require('./flag-pt')
require('./flag-us')
require('./generic_avatar_lv1_bb1')
require('./generic_avatar_lv10_fs')
require('./generic_avatar_lv2_bb2')
require('./generic_avatar_lv3_bb3')
require('./generic_avatar_lv4_adap')
require('./generic_avatar_lv5_inic')
require('./generic_avatar_lv6_ap1')
require('./generic_avatar_lv7_ap2')
require('./generic_avatar_lv8_ap3')
require('./generic_avatar_lv9_eq')
require('./generic_person_icon')
require('./icn_admin')
require('./icn_api')
require('./icn_arrow')
require('./icn_assessment-complete')
require('./icn_assessment')
require('./icn_attendance')
require('./icn_avatar')
require('./icn_award')
require('./icn_bell')
require('./icn_brand-ytb')
require('./icn_certification')
require('./icn_circle')
require('./icn_class')
require('./icn_classroom')
require('./icn_clock')
require('./icn_close-simple')
require('./icn_cloud')
require('./icn_comments')
require('./icn_config')
require('./icn_content')
require('./icn_courses')
require('./icn_customers')
require('./icn_dashboard')
require('./icn_details-growth-1')
require('./icn_details-growth-2')
require('./icn_details-growth-3')
require('./icn_details-growth-4')
require('./icn_details-growth-5')
require('./icn_down')
require('./icn_download')
require('./icn_duplicate')
require('./icn_edit')
require('./icn_empty-state')
require('./icn_empty-uploader')
require('./icn_empty')
require('./icn_error')
require('./icn_error2')
require('./icn_excel')
require('./icn_external_link')
require('./icn_eye')
require('./icn_failed')
require('./icn_file')
require('./icn_filter')
require('./icn_folder')
require('./icn_garbage')
require('./icn_glasses')
require('./icn_hide')
require('./icn_image')
require('./icn_info')
require('./icn_left')
require('./icn_level')
require('./icn_library')
require('./icn_licensed')
require('./icn_locals')
require('./icn_lock')
require('./icn_logo')
require('./icn_logout')
require('./icn_mapa')
require('./icn_menu')
require('./icn_more')
require('./icn_networks')
require('./icn_niveis')
require('./icn_objetivos')
require('./icn_pause')
require('./icn_pdf')
require('./icn_pedagogical')
require('./icn_plans')
require('./icn_plus')
require('./icn_pool')
require('./icn_powerPoint')
require('./icn_question')
require('./icn_reload')
require('./icn_replace')
require('./icn_right')
require('./icn_roles')
require('./icn_schedule_hour')
require('./icn_schedule_map')
require('./icn_schedule_simple')
require('./icn_schedule')
require('./icn_sea-waves')
require('./icn_search')
require('./icn_share')
require('./icn_shop')
require('./icn_students')
require('./icn_success')
require('./icn_sucess')
require('./icn_switch_profile')
require('./icn_teacher')
require('./icn_text')
require('./icn_unlimited')
require('./icn_unlock')
require('./icn_upload')
require('./icn_user_admin')
require('./icn_users')
require('./icn_view')
require('./icn_warning')
require('./icon_change')
require('./icon_location')
require('./icon_out')
require('./icon_user')
require('./level_icon_inactive')
require('./question-circle')
